module.exports = __webpack_public_path__ + "static/img/cont64 (7).7276b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (7).jpg
// module id = ZeEx
// module chunks = 0